import { Dayjs } from 'dayjs'
import { Servicepoint, ServicepointOpeningsTime } from './model.js'

const minutesUntilServicepointClosure = ({ timeTo, weekDay }: ServicepointOpeningsTime, now: Dayjs): number => {
  const today = now.clone()

  const difference = today
    .hour(timeTo.hour())
    .minute(timeTo.minute())
    .add(weekDay - (today.day() % 7), 'day')
    .diff(now, 'minute')

  return difference > 0 ? difference : Number.MAX_VALUE
}

export const getFirstOpeningsTime = (servicepoint: Servicepoint, now: Dayjs): ServicepointOpeningsTime | undefined => {
  const [firstOpeningTime] = servicepoint.openingsTimes
    .filter((openingsTime) => minutesUntilServicepointClosure(openingsTime, now) > 0)
    .sort((a, b) => minutesUntilServicepointClosure(a, now) - minutesUntilServicepointClosure(b, now))

  return firstOpeningTime
}
